import { Outlet } from "react-router-dom";

export function Coupon() {
  return (
    <>
      <Outlet />
    </>
  );
}
